import { savePrevPath } from 'actions'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const URLprotocolHandler = () => {
  const dispatch = useDispatch()

  const pathname = useSelector(s => s.router.location.pathname)

  useEffect(() => {
    function handleWindowsActivated(activatedEventArgs) {
      if (
        activatedEventArgs.kind ===
        window.Windows.ApplicationModel.Activation.ActivationKind.protocol
      ) {
        const path = activatedEventArgs?.uri?.path

        if (path && !pathname.includes(path)) {
          dispatch(savePrevPath(path))
        }
      }
    }

    if (window.Windows) {
      window.Windows.UI.WebUI.WebUIApplication.addEventListener(
        'activated',
        handleWindowsActivated,
        false
      )
    }

    return () => {
      if (window.Windows) {
        window.Windows.UI.WebUI.WebUIApplication.removeEventListener(
          'activated',
          handleWindowsActivated
        )
      }
    }
  }, [dispatch, pathname])

  return null
}

export default URLprotocolHandler
